/**
 * Pacarion's own brand for a homeowner with no sponsor.
 * CommonJS only. No object spread: the iOS bundle cannot load Babel's spread helper.
 */

const PACARION_BRAND_COLOR = '#59c4c4';
const PACARION_WORDMARK = 'PACARION';
const PACARION_TAGLINE = 'Everything home, in one place, branded to you.';
const PACARION_POSTAL_ADDRESS = 'PO Box 530213, DeBary, FL 32753';
const PACARION_SUPPORT_EMAIL = 'support@pacarion.com';

function postalPlainLine() {
  return `Pacarion LLC, ${PACARION_POSTAL_ADDRESS}`;
}

function textWithPostal(text) {
  const body = String(text || '').replace(/\s+$/g, '');
  if (body.indexOf(PACARION_POSTAL_ADDRESS) !== -1) return body;
  if (!body) return postalPlainLine();
  return `${body}\n\n${postalPlainLine()}`;
}

module.exports = {
  PACARION_BRAND_COLOR,
  PACARION_WORDMARK,
  PACARION_TAGLINE,
  PACARION_POSTAL_ADDRESS,
  PACARION_SUPPORT_EMAIL,
  postalPlainLine,
  textWithPostal,
};
